import React, { useContext, useMemo } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import IconTitle from "../../../shared/components/IconTitle";
import MainButton from "../../../shared/components/MainButton";
import Text from "../../../shared/components/Text";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { CAPTURE_MODES, getDocumentIdDocumentLabel } from "../config";

export const ProcessInformation = ({ onSubmitForm }) => {
  const { palette } = useTheme();
  const {
    state: { idDocumentVerification },
  } = useContext(ProcessContext);

  const recommendationTips = useMemo(
    () => [
      { icon: "badge", tId: "PROCESS_INFO_BULLET_ORIGINAL" },
      { icon: "calendar_month", tId: "PROCESS_INFO_BULLET_NOT_EXPIRED" },
      { icon: "horizontal_rule", tId: "PROCESS_INFO_BULLET_HORIZONTAL" },
      { icon: "light_mode", tId: "PROCESS_INFO_BULLET_GOOD_LIGHTING" },
    ],
    []
  );

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          title={
            <Text
              tId="DOCUMENT_ID_VERIFICATION"
              dynamicDataTexts={[
                getDocumentIdDocumentLabel(idDocumentVerification.documentType),
              ]}
            />
          }
          subtitle={<Text tId="INSTRUCTIONS_FOR_DOCUMENT_VERIFICATION" />}
        />
      </Box>
      <Box>
        <Box
          maxWidth={420}
          mx="auto"
          display="flex"
          flexDirection="column"
          gridGap={14}
        >
          {recommendationTips.map((tip) => (
            <Box key={tip.tId} display="flex" gridGap={26} alignItems="center">
              <i
                className="material-icons"
                style={{
                  fontSize: "38px",
                  color: palette.primary.main,
                  lineHeight: "38px",
                }}
              >
                {tip.icon}
              </i>
              <Typography
                style={{ color: palette.text.title }}
                variant="subtitle2"
              >
                <Text tId={tip.tId} />
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Box height={10}></Box>
      <Box height={10}></Box>
      <Box>
        <Box display="flex" flexDirection="column">
          <Button
            className="progression"
            style={{
              width: "100%",
              marginTop: "24px",
              marginBottom: "-8px",
              height: 48,
            }}
            variant="outlined"
            color="primary"
            onClick={() => onSubmitForm({ captureMode: CAPTURE_MODES.UPLOAD })}
          >
            <Text tId="UPLOAD_PICTURES" />
          </Button>
          <MainButton
            onClick={() => onSubmitForm({ captureMode: CAPTURE_MODES.CAMERA })}
          >
            <Text tId="TAKE_PICTURE" />
          </MainButton>
        </Box>
      </Box>
    </>
  );
};
